import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tplToWork && _vm.defaultFields
        ? _c(
            VForm,
            { ref: "form", staticClass: "form", on: { submit: _vm.onSubmit } },
            [
              _c(
                "div",
                [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("joinTableReference")(
                          _vm.tplToWork.item.tableReference
                        )
                      )
                    ),
                  ]),
                  _c(
                    VBtn,
                    {
                      staticClass: "btn-icon-inca",
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.copyObject()
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-share-variant-outline")])],
                    1
                  ),
                ],
                1
              ),
              _c("hr", { staticClass: "mb-0" }),
              _c(
                VTabs,
                {
                  attrs: { elevation: 5, "show-arrows": "" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.current = "General"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.general")))]
                  ),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.current = "Columns"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.columns")))]
                  ),
                  _vm.showSampleTab
                    ? _c(VTab, { on: { click: _vm.onOpenSampleTab } }, [
                        _vm._v(_vm._s(_vm.$t("my_tasks.modals.sample_data"))),
                      ])
                    : _vm._e(),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.current = "bterm"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.bterm")))]
                  ),
                  !(_vm.tplToWork.item.source == "synapse")
                    ? _c(VTab, [
                        _vm._v(_vm._s(_vm.$t("my_tasks.modals.profiling"))),
                      ])
                    : _vm._e(),
                  !(_vm.tplToWork.item.source == "synapse")
                    ? _c(VTab, [
                        _vm._v(_vm._s(_vm.$t("my_tasks.modals.quality_dp"))),
                      ])
                    : _vm._e(),
                  _c(VTab, [
                    _vm._v(_vm._s(_vm.$t("my_tasks.modals.hlogs"))),
                  ]),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "p-0 font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.organization"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _vm.isEdited("ORGANIZATION")
                                        ? _c(VSelect, {
                                            attrs: {
                                              items: _vm.organizations,
                                              outlined:
                                                _vm.isEdited("ORGANIZATION"),
                                              dense: "",
                                              filled:
                                                !_vm.isEdited("ORGANIZATION"),
                                              readonly:
                                                !_vm.isEdited("ORGANIZATION"),
                                              rules: [
                                                function (v) {
                                                  return (
                                                    _vm.organizations.includes(
                                                      v
                                                    ) ||
                                                    _vm.$t(
                                                      "my_tasks.modals.required"
                                                    )
                                                  )
                                                },
                                                function (v) {
                                                  return (
                                                    !!v ||
                                                    _vm.$t(
                                                      "my_tasks.modals.required"
                                                    )
                                                  )
                                                },
                                              ],
                                              size: "sm",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .ORGANIZATION.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .ORGANIZATION.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue",
                                            },
                                          })
                                        : _c(VTextField, {
                                            attrs: {
                                              outlined:
                                                _vm.isEdited("ORGANIZATION"),
                                              filled:
                                                !_vm.isEdited("ORGANIZATION"),
                                              dense: "",
                                              type: "text",
                                              readonly:
                                                !_vm.isEdited("ORGANIZATION"),
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .ORGANIZATION.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .ORGANIZATION.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.domain")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          items: _vm.selectDomain,
                                          "item-value": "text",
                                          "item-text": "text",
                                          rules: [
                                            function (v) {
                                              return (
                                                !!v ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                          ],
                                          dense: "",
                                          readonly: !_vm.isEdited("DOMAIN"),
                                          outlined: _vm.isEdited("DOMAIN"),
                                          filled: !_vm.isEdited("DOMAIN"),
                                          size: "sm",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS.DOMAIN
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.DOMAIN.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.subdomain"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          items: _vm.filterSubdomain,
                                          "item-value": "text",
                                          "item-text": "text",
                                          dense: "",
                                          rules: [
                                            function (v) {
                                              return (
                                                !!v ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                          ],
                                          readonly: !_vm.isEdited("SUBDOMAIN"),
                                          outlined: _vm.isEdited("SUBDOMAIN"),
                                          filled: !_vm.isEdited("SUBDOMAIN"),
                                          size: "sm",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.SUBDOMAIN.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.official_source"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          rules: [
                                            function (v) {
                                              return (
                                                !!v ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                          ],
                                          size: "sm",
                                          type: "text",
                                          dense: "",
                                          readonly:
                                            !_vm.isEdited("OFFICIAL_SOURCE"),
                                          outlined:
                                            _vm.isEdited("OFFICIAL_SOURCE"),
                                          filled:
                                            !_vm.isEdited("OFFICIAL_SOURCE"),
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .OFFICIAL_SOURCE.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .OFFICIAL_SOURCE.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.operator")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          dense: "",
                                          rules: _vm.isEdited("OPERATOR")
                                            ? [
                                                _vm.rules.required,
                                                _vm.rules.emailFormat,
                                              ]
                                            : [],
                                          "error-messages": _vm.isEdited(
                                            "OPERATOR"
                                          )
                                            ? _vm.operatorValidator.state.errors
                                            : [],
                                          loading:
                                            _vm.operatorValidator.state.loading,
                                          disabled:
                                            _vm.operatorValidator.state.loading,
                                          readonly: !_vm.isEdited("OPERATOR"),
                                          outlined: _vm.isEdited("OPERATOR"),
                                          filled: !_vm.isEdited("OPERATOR"),
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.isEdited("OPERATOR") &&
                                              (_vm.operatorValidator.state.errors =
                                                [])
                                          },
                                          blur: function ($event) {
                                            _vm.isEdited("OPERATOR") &&
                                              _vm.operatorValidator.validate(
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .OPERATOR.name
                                                ].stringValue
                                              )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          false
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("my_tasks.modals.area")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              items: _vm.select_areas,
                                              readonly:
                                                !_vm.isEdited("AREA") ||
                                                !_vm.isPublicTable,
                                              dense: "",
                                              outlined: _vm.isEdited("AREA"),
                                              filled: !_vm.isEdited("AREA"),
                                              size: "sm",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS.AREA
                                                    .name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS.AREA
                                                      .name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.AREA.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.hideEnv
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.environment"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              items:
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ENVIRONMENT.enumValues,
                                              dense: "",
                                              readonly:
                                                !_vm.isEdited("ENVIRONMENT"),
                                              outlined:
                                                _vm.isEdited("ENVIRONMENT"),
                                              filled:
                                                !_vm.isEdited("ENVIRONMENT"),
                                              size: "sm",
                                            },
                                            on: {
                                              change: _vm.changeEnviroment,
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .ENVIRONMENT.name
                                                ].enumValue.displayName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .ENVIRONMENT.name
                                                  ].enumValue,
                                                  "displayName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.zone")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          items: _vm.select_zones,
                                          dense: "",
                                          readonly: !_vm.isEdited("ZONE"),
                                          outlined: _vm.isEdited("ZONE"),
                                          filled: !_vm.isEdited("ZONE"),
                                          size: "sm",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.ZONE.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "p-0 font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.public")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VCheckbox, {
                                        attrs: {
                                          value: true,
                                          dense: "",
                                          readonly: !_vm.isEdited("PUBLIC"),
                                          outlined: _vm.isEdited("PUBLIC"),
                                          filled: !_vm.isEdited("PUBLIC"),
                                          pattern: _vm.getPattern(
                                            _vm.DEFAULT_TPL_FIELDS.PUBLIC
                                          ),
                                          size: "sm",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                            ].boolValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS.PUBLIC
                                                  .name
                                              ],
                                              "boolValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.PUBLIC.name].boolValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.showAuthorizationTypeSelector
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.authorization_type"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              items:
                                                _vm.authorizationTypeOptions,
                                              dense: "",
                                              readonly: !_vm.isEdited("PUBLIC"),
                                              outlined: _vm.isEdited("PUBLIC"),
                                              filled: !_vm.isEdited("PUBLIC"),
                                              "hide-details": "auto",
                                              "item-text": "text",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.authorizationType,
                                              callback: function ($$v) {
                                                _vm.authorizationType = $$v
                                              },
                                              expression: "authorizationType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.bus_data_steward"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              rules: _vm.isEdited(
                                                "BUS_DATA_STEWARD"
                                              )
                                                ? [_vm.rules.emailRequired]
                                                : [],
                                              "error-messages": _vm.isEdited(
                                                "BUS_DATA_STEWARD"
                                              )
                                                ? _vm.busDataStewardValidator
                                                    .state.errors
                                                : [],
                                              loading:
                                                _vm.busDataStewardValidator
                                                  .state.loading,
                                              disabled:
                                                _vm.busDataStewardValidator
                                                  .state.loading,
                                              readonly:
                                                !_vm.isEdited(
                                                  "BUS_DATA_STEWARD"
                                                ),
                                              outlined:
                                                _vm.isEdited(
                                                  "BUS_DATA_STEWARD"
                                                ),
                                              filled:
                                                !_vm.isEdited(
                                                  "BUS_DATA_STEWARD"
                                                ),
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.isEdited(
                                                  "BUS_DATA_STEWARD"
                                                ) &&
                                                  (_vm.busDataStewardValidator.state.errors =
                                                    [])
                                              },
                                              blur: function ($event) {
                                                _vm.isEdited(
                                                  "BUS_DATA_STEWARD"
                                                ) &&
                                                  _vm.busDataStewardValidator.validate(
                                                    _vm.defaultFields[
                                                      _vm.DEFAULT_TPL_FIELDS
                                                        .BUS_DATA_STEWARD.name
                                                    ].stringValue
                                                  )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .BUS_DATA_STEWARD.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .BUS_DATA_STEWARD.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.DATA_OWNER.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.data_owner"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              rules: _vm.isEdited("DATA_OWNER")
                                                ? [_vm.rules.emailRequired]
                                                : [],
                                              "error-messages": _vm.isEdited(
                                                "DATA_OWNER"
                                              )
                                                ? _vm.dataOwnerValidator.state
                                                    .errors
                                                : [],
                                              loading:
                                                _vm.dataOwnerValidator.state
                                                  .loading,
                                              disabled:
                                                _vm.dataOwnerValidator.state
                                                  .loading,
                                              readonly:
                                                !_vm.isEdited("DATA_OWNER"),
                                              outlined:
                                                _vm.isEdited("DATA_OWNER"),
                                              filled:
                                                !_vm.isEdited("DATA_OWNER"),
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.isEdited("DATA_OWNER") &&
                                                  (_vm.dataOwnerValidator.state.errors =
                                                    [])
                                              },
                                              blur: function ($event) {
                                                _vm.isEdited("DATA_OWNER") &&
                                                  _vm.dataOwnerValidator.validate(
                                                    _vm.defaultFields[
                                                      _vm.DEFAULT_TPL_FIELDS
                                                        .DATA_OWNER.name
                                                    ].stringValue
                                                  )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .DATA_OWNER.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .DATA_OWNER.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.DATA_OWNER.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.tech_data_custodiam"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              rules: _vm.isEdited(
                                                "TECH_DATA_CUSTODIAM"
                                              )
                                                ? [_vm.rules.emailRequired]
                                                : [],
                                              "error-messages": _vm.isEdited(
                                                "TECH_DATA_CUSTODIAM"
                                              )
                                                ? _vm.techDataCustodiamValidator
                                                    .state.errors
                                                : [],
                                              loading:
                                                _vm.techDataCustodiamValidator
                                                  .state.loading,
                                              disabled:
                                                _vm.techDataCustodiamValidator
                                                  .state.loading,
                                              readonly: !_vm.isEdited(
                                                "TECH_DATA_CUSTODIAM"
                                              ),
                                              outlined: _vm.isEdited(
                                                "TECH_DATA_CUSTODIAM"
                                              ),
                                              filled: !_vm.isEdited(
                                                "TECH_DATA_CUSTODIAM"
                                              ),
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.isEdited(
                                                  "TECH_DATA_CUSTODIAM"
                                                ) &&
                                                  (_vm.techDataCustodiamValidator.state.errors =
                                                    [])
                                              },
                                              blur: function ($event) {
                                                _vm.isEdited(
                                                  "TECH_DATA_CUSTODIAM"
                                                ) &&
                                                  _vm.techDataCustodiamValidator.validate(
                                                    _vm.defaultFields[
                                                      _vm.DEFAULT_TPL_FIELDS
                                                        .TECH_DATA_CUSTODIAM
                                                        .name
                                                    ].stringValue
                                                  )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TECH_DATA_CUSTODIAM.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TECH_DATA_CUSTODIAM.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.FINAL_TABLE.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.final_table"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VCheckbox, {
                                            attrs: {
                                              value: true,
                                              dense: "",
                                              readonly:
                                                !_vm.isEdited("FINAL_TABLE"),
                                              outlined:
                                                _vm.isEdited("FINAL_TABLE"),
                                              filled:
                                                !_vm.isEdited("FINAL_TABLE"),
                                              size: "sm",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .FINAL_TABLE.name
                                                ].boolValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .FINAL_TABLE.name
                                                  ],
                                                  "boolValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.FINAL_TABLE.name].boolValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.upload_platform"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              readonly:
                                                !_vm.isEdited(
                                                  "UPLOAD_PLATFORM"
                                                ),
                                              outlined:
                                                _vm.isEdited("UPLOAD_PLATFORM"),
                                              filled:
                                                !_vm.isEdited(
                                                  "UPLOAD_PLATFORM"
                                                ),
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .UPLOAD_PLATFORM.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .UPLOAD_PLATFORM.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.upload_process"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              readonly:
                                                !_vm.isEdited("UPLOAD_PROCESS"),
                                              outlined:
                                                _vm.isEdited("UPLOAD_PROCESS"),
                                              filled:
                                                !_vm.isEdited("UPLOAD_PROCESS"),
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .UPLOAD_PROCESS.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .UPLOAD_PROCESS.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.load_logic"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              readonly:
                                                !_vm.isEdited(
                                                  "TABLE_LOAD_LOGIC"
                                                ),
                                              outlined:
                                                _vm.isEdited(
                                                  "TABLE_LOAD_LOGIC"
                                                ),
                                              filled:
                                                !_vm.isEdited(
                                                  "TABLE_LOAD_LOGIC"
                                                ),
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TABLE_LOAD_LOGIC.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TABLE_LOAD_LOGIC.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name
                          ]
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "12", md: "12" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-12" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.tables_relationship"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-12" },
                                        [
                                          _c(VTextarea, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              rows: "2",
                                              readonly: !_vm.isEdited(
                                                "TABLES_RELATIONSHIP"
                                              ),
                                              outlined: _vm.isEdited(
                                                "TABLES_RELATIONSHIP"
                                              ),
                                              filled: !_vm.isEdited(
                                                "TABLES_RELATIONSHIP"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TABLES_RELATIONSHIP.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TABLES_RELATIONSHIP.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.tplToWork.item &&
                          _vm.tplToWork.item.partition != null
                            ? _c(
                                VCol,
                                { attrs: { sm: "12", lg: "4" } },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [_vm._v("Partición:")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              dense: "",
                                              readonly: "",
                                              filled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.tplToWork.item.partition,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.tplToWork.item,
                                                  "partition",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "tplToWork.item.partition",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.isChangeRequest == _vm.TYPE_CHANGE_METADA.VIEWER_ONLY
                        ? _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isTableOwnerLogged,
                                      expression: "isTableOwnerLogged",
                                    },
                                  ],
                                  attrs: { sm: "12", lg: "4" },
                                },
                                [
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.files"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                outlined: "",
                                                color: "secondary",
                                                small: "",
                                                rounded: "",
                                                dense: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.$refs.fileInput2.$el
                                                    .querySelector(
                                                      "input[type=file]"
                                                    )
                                                    .click()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-paperclip")]
                                              ),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.attach"
                                                  )
                                                )
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("b-form-file", {
                                            ref: "fileInput2",
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              accept:
                                                _vm.METADATA_FILE_FORMAT.join(
                                                  ","
                                                ),
                                            },
                                            on: { change: _vm.onFileChange },
                                            model: {
                                              value: _vm.inputUploadFile,
                                              callback: function ($$v) {
                                                _vm.inputUploadFile = $$v
                                              },
                                              expression: "inputUploadFile",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.files.length,
                                      expression: "files.length",
                                    },
                                  ],
                                  attrs: { sm: "12", lg: "4" },
                                },
                                [
                                  _c(
                                    "b-table-simple",
                                    { attrs: { small: true, hover: true } },
                                    [
                                      _c(
                                        "b-thead",
                                        [
                                          _c(
                                            "b-tr",
                                            [
                                              _c("b-th", [_vm._v("Files")]),
                                              _c("b-th", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isTableOwnerLogged,
                                                    expression:
                                                      "isTableOwnerLogged",
                                                  },
                                                ],
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-tbody",
                                        _vm._l(
                                          _vm.files,
                                          function (file, index) {
                                            return _c(
                                              "b-tr",
                                              { key: index },
                                              [
                                                _c("b-td", [
                                                  _vm.METADATA_IMAGE_FORMAT.filter(
                                                    function (format) {
                                                      return file.fileName
                                                        .toLowerCase()
                                                        .endsWith(format)
                                                    }
                                                  ).length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            cursor: "pointer",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onClickLink(
                                                                file
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.fileName
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            color: "#515154",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openImage(
                                                                file.fileLink
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.fileName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                ]),
                                                _c(
                                                  "b-td",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.isTableOwnerLogged,
                                                        expression:
                                                          "isTableOwnerLogged",
                                                      },
                                                    ],
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                        attrs: {
                                                          title: "Delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteFile(
                                                              file
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                            staticStyle: {
                                                              color: "blue",
                                                              "font-size":
                                                                "medium",
                                                            },
                                                          },
                                                          [_vm._v("delete")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.currentFile.fileLink &&
                                        _vm.METADATA_IMAGE_FORMAT.filter(
                                          function (file) {
                                            return _vm.currentFile.fileName
                                              .toLowerCase()
                                              .endsWith(file)
                                          }
                                        ).length,
                                      expression:
                                        "currentFile.fileLink && METADATA_IMAGE_FORMAT.filter(file => currentFile.fileName.toLowerCase().endsWith(file)).length",
                                    },
                                  ],
                                  attrs: { sm: "12", lg: "6" },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.currentFile.fileLink,
                                        download: _vm.currentFile.fileName,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("b-img", {
                                        attrs: {
                                          src: _vm.currentFile.fileLink,
                                          fluid: "",
                                          alt: _vm.currentFile.fileName,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(VCol, { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "pb-2 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.modals.table_desc"))
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            VCol,
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  outlined: _vm.isEdited("DESCRIPTION"),
                                  placeholder: _vm.$t("my_tasks.modals.files"),
                                  dense: "",
                                  filled: !_vm.isEdited("DESCRIPTION"),
                                  readonly: !_vm.isEdited("DESCRIPTION"),
                                  required: _vm.getRequired(
                                    _vm.DEFAULT_TPL_FIELDS.DESCRIPTION
                                  ),
                                  pattern: _vm.getPattern(
                                    _vm.DEFAULT_TPL_FIELDS.DESCRIPTION
                                  ),
                                  size: "sm",
                                  "hide-details": "auto",
                                  rules:
                                    _vm.defaultFields[
                                      _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT.name
                                    ].enumValue.displayName == "prod"
                                      ? [
                                          function (v) {
                                            return (
                                              (v !== "Null" && !!v) ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                          _vm.unicodeCharLimit,
                                        ]
                                      : [_vm.unicodeCharLimit],
                                  "persistent-hint": "",
                                },
                                on: { input: _vm.handleInput },
                                model: {
                                  value: _vm.completeDescription,
                                  callback: function ($$v) {
                                    _vm.completeDescription = $$v
                                  },
                                  expression: "completeDescription",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  key: _vm.key_description,
                                  staticClass: "text-right",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.DESC_CHARACTERS_COUNT) +
                                      " / " +
                                      _vm._s(_vm.MAX_CHARACTERS)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c("list-table-metadata-cols-component", {
                        attrs: {
                          columnFields: _vm.columnFields,
                          defaultFields: _vm.defaultFields,
                          isChangeRequest: _vm.isChangeRequest,
                          filter: _vm.filter,
                          lazyLoadParams: _vm.lazyLoadParamsForColumns,
                        },
                        on: { loadColumns: _vm.onLoadColumns },
                      }),
                    ],
                    1
                  ),
                  _vm.showSampleTab
                    ? _c(
                        VTabItem,
                        [
                          _c(
                            VContainer,
                            { staticClass: "pt-2", attrs: { fluid: "" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", align: "center" } },
                                [
                                  _c(VCol, [
                                    _c(
                                      "span",
                                      { staticClass: "caption grey--text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "my_tasks.modals.sample_data_hint",
                                              { n: _vm.SAMPLE_ROWS_LIMIT }
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            small: "",
                                            outlined: "",
                                            color: "primary",
                                            loading: _vm.sampleLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.loadSampleRows(true)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-refresh")]
                                          ),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.sample_data_load"
                                              )
                                            )
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.sampleLoading
                                ? _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { sm: "12" } },
                                        [_c("base-loading")],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.sampleError
                                ? _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { sm: "12" } },
                                        [
                                          _c(
                                            VAlert,
                                            {
                                              attrs: {
                                                type: "warning",
                                                text: "",
                                                dense: "",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.sampleError))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.sampleLoaded && !_vm.sampleRows.length
                                ? _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { sm: "12" } },
                                        [
                                          _c(
                                            VAlert,
                                            {
                                              attrs: {
                                                type: "info",
                                                text: "",
                                                dense: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.sample_data_empty"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.sampleRows.length
                                ? _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        {
                                          staticStyle: { "overflow-x": "auto" },
                                          attrs: { sm: "12" },
                                        },
                                        [
                                          _c(VDataTable, {
                                            staticClass: "table-inca",
                                            attrs: {
                                              headers: _vm.sampleHeaders,
                                              items: _vm.sampleRows,
                                              dense: "",
                                              "items-per-page":
                                                _vm.SAMPLE_ROWS_LIMIT,
                                              "hide-default-footer": "",
                                              "fixed-header": "",
                                              height: "420",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VTabItem,
                    [
                      _c("tab-metadata-business-terms-component", {
                        attrs: {
                          columnFields: _vm.columnFields,
                          relativeResourceName: _vm.relativeResourceName,
                          domainTable: _vm.domain_table,
                          validUserAccess: _vm.validUserAccess,
                          isChangeRequest: _vm.isChangeRequest,
                          dataOperator:
                            _vm.defaultFields[
                              _vm.DEFAULT_TPL_FIELDS.OPERATOR.name
                            ].stringValue,
                          source: _vm.tplToWork.item.source
                            ? _vm.tplToWork.item.source
                            : "bigquery",
                        },
                        on: { cancel2: _vm.onCancel },
                      }),
                    ],
                    1
                  ),
                  !(_vm.tplToWork.item.source == "synapse")
                    ? _c(
                        VTabItem,
                        [
                          _c(
                            VRow,
                            { staticClass: "mt-2" },
                            [
                              _c(
                                VCol,
                                { attrs: { col: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.dataplex_profilings,
                                      label: "Perfilamiento",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      "return-object": "",
                                      "item-text": "display_name",
                                    },
                                    on: {
                                      change: _vm.onChangeDataplexProfiling,
                                    },
                                    model: {
                                      value: _vm.dataplex_profiling,
                                      callback: function ($$v) {
                                        _vm.dataplex_profiling = $$v
                                      },
                                      expression: "dataplex_profiling",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { col: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.dataplex_profiling_executions,
                                      label: "Ejecuciones",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      "return-object": "",
                                      "item-text": function (item) {
                                        return (
                                          new Date(
                                            item.created_date
                                          ).toLocaleString() +
                                          " (" +
                                          _vm.DATAPLEX_STATES[item.state] +
                                          ")"
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.dataplex_profiling_execution,
                                      callback: function ($$v) {
                                        _vm.dataplex_profiling_execution = $$v
                                      },
                                      expression:
                                        "dataplex_profiling_execution",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                [
                                  _c("ProfilingExecutionDetailComponent", {
                                    key: _vm.key_table_execution_profiling,
                                    attrs: {
                                      items:
                                        _vm.dataplex_profiling_execution &&
                                        _vm.dataplex_profiling_execution
                                          .dataProfileResult &&
                                        _vm.dataplex_profiling_execution
                                          .dataProfileResult.profile &&
                                        _vm.dataplex_profiling_execution
                                          .dataProfileResult.profile.fields
                                          ? _vm.dataplex_profiling_execution
                                              .dataProfileResult.profile.fields
                                          : [],
                                      profiling: _vm.dataplex_profiling,
                                      execution:
                                        _vm.dataplex_profiling_execution,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !(_vm.tplToWork.item.source == "synapse")
                    ? _c(
                        VTabItem,
                        [
                          _c(
                            VRow,
                            { staticClass: "mt-2" },
                            [
                              _c(
                                VCol,
                                { attrs: { col: "4" } },
                                [
                                  _c(VSwitch, {
                                    staticClass: "mt-0",
                                    attrs: {
                                      label: "¿Calidad de Datos Dataplex?",
                                      "hide-details": "auto",
                                    },
                                    on: { change: _vm.onChangeDataplexFlag },
                                    model: {
                                      value: _vm.show_dataplex_quality,
                                      callback: function ($$v) {
                                        _vm.show_dataplex_quality = $$v
                                      },
                                      expression: "show_dataplex_quality",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.show_dataplex_quality
                                ? _c(
                                    VCol,
                                    { attrs: { col: "4" } },
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          items: _vm.dataplex_qualities,
                                          label: "Calidad de Datos",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "auto",
                                          "return-object": "",
                                          "item-text": "display_name",
                                        },
                                        on: {
                                          change: _vm.onChangeDataplexQuality,
                                        },
                                        model: {
                                          value: _vm.dataplex_quality,
                                          callback: function ($$v) {
                                            _vm.dataplex_quality = $$v
                                          },
                                          expression: "dataplex_quality",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.show_dataplex_quality
                                ? _c(
                                    VCol,
                                    { attrs: { col: "4" } },
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          items:
                                            _vm.dataplex_quality_executions,
                                          label: "Ejecuciones",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "auto",
                                          "return-object": "",
                                          "item-text": function (item) {
                                            return (
                                              item.created_date_desc +
                                              " (" +
                                              _vm.DATAPLEX_STATES[item.state] +
                                              ")"
                                            )
                                          },
                                        },
                                        on: {
                                          change: _vm.onCompleteRulesQuality,
                                        },
                                        model: {
                                          value: _vm.dataplex_quality_execution,
                                          callback: function ($$v) {
                                            _vm.dataplex_quality_execution = $$v
                                          },
                                          expression:
                                            "dataplex_quality_execution",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.show_dataplex_quality
                            ? _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c("QualityExecutionDetailComponent", {
                                        attrs: {
                                          items:
                                            _vm.dataplex_quality_execution
                                              .dataQualityResult &&
                                            _vm.dataplex_quality_execution
                                              .dataQualityResult.rules
                                              ? _vm.dataplex_quality_execution
                                                  .dataQualityResult.rules
                                              : [],
                                          key_component:
                                            _vm.key_table_execution_quality,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.show_dataplex_quality
                            ? _c(
                                VContainer,
                                { attrs: { fluid: "" } },
                                [
                                  _vm.selectProfilingRules.length === 0
                                    ? _c(
                                        VRow,
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            VCol,
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "There are not defined rules for this table"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        VRow,
                                        [
                                          _c(
                                            VRow,
                                            { staticClass: "pl-1" },
                                            [
                                              _c(
                                                VCol,
                                                { attrs: { cols: "2" } },
                                                [
                                                  _c(
                                                    VSubheader,
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s("Profiling Rule")
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VCol,
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(VSelect, {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      small: "",
                                                      id: "rule-input",
                                                      size: "sm",
                                                      items:
                                                        _vm.selectProfilingRules,
                                                      "item-value":
                                                        "document_id",
                                                      "item-text": "format",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.getExecutions()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.currentRule,
                                                      callback: function ($$v) {
                                                        _vm.currentRule = $$v
                                                      },
                                                      expression: "currentRule",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                  !_vm.isLoadingExecutions
                                    ? _c("profiling-table-result", {
                                        attrs: {
                                          documentId: _vm.currentRule,
                                          domainTable: _vm.domain_table,
                                          tableReference:
                                            _vm.tplToWork.item.tableReference,
                                          readonly: !_vm.isTableOwnerLogged,
                                        },
                                        on: {
                                          closeModal: function ($event) {
                                            return _vm.$emit("cancel")
                                          },
                                        },
                                      })
                                    : _c(
                                        VCol,
                                        { attrs: { sm: "12" } },
                                        [_c("base-loading")],
                                        1
                                      ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  !(_vm.tplToWork.item.source == "synapse")
                    ? _c(
                        VTabItem,
                        [
                          _c(
                            VContainer,
                            { attrs: { fluid: "" } },
                            [
                              _c("LineageComponent", {
                                attrs: { table: _vm.tplToWork },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VTabItem,
                    [
                      _c("list-table-logs", {
                        ref: "refTableLog",
                        attrs: {
                          objectId: _vm.tplToWork.item.relativeResourceName,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.current !== "bterm",
                      expression: "current !== 'bterm'",
                    },
                  ],
                },
                [
                  _vm.tplToWork.tipo == "vista"
                    ? [
                        _c(
                          VRow,
                          [
                            _c(
                              VCol,
                              { attrs: { sm: "12", lg: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: _vm.$t(
                                        "my_tasks.modals.request_reason"
                                      ),
                                    },
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      staticClass: "input-mini",
                                      attrs: {
                                        disabled: "",
                                        size: "sm",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        required: "",
                                        placeholder: "Message to request...",
                                      },
                                      model: {
                                        value: _vm.tplToWork.item.commentary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tplToWork.item,
                                            "commentary",
                                            $$v
                                          )
                                        },
                                        expression: "tplToWork.item.commentary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          [
                            _c(
                              VCol,
                              { attrs: { sm: "12", lg: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: _vm.$t(
                                        "my_tasks.modals.response_reason"
                                      ),
                                    },
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      staticClass: "input-mini",
                                      attrs: {
                                        disabled: "",
                                        size: "sm",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        required: "",
                                        placeholder: "Message to response...",
                                      },
                                      model: {
                                        value: _vm.tplToWork.item.response,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tplToWork.item,
                                            "response",
                                            $$v
                                          )
                                        },
                                        expression: "tplToWork.item.response",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.tplToWork.tipo != "vista"
                    ? [
                        _vm.isChangeRequest ==
                          _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST &&
                        _vm.tplToWork.tipo == "edicion" &&
                        _vm.tab != 2 &&
                        _vm.tab != 4 &&
                        _vm.tab != 3 &&
                        _vm.tab != 5
                          ? _c(
                              VRow,
                              { attrs: { dense: "" } },
                              [
                                _c(VCol, { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "pb-2 font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "my_tasks.modals.request_reason"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  VCol,
                                  { staticClass: "col-md-12" },
                                  [
                                    _c(VTextarea, {
                                      attrs: {
                                        size: "sm",
                                        rows: "3",
                                        "max-rows": "3",
                                        outlined: true,
                                        type: "text",
                                        required: "",
                                        rules: [
                                          function (v) {
                                            return (
                                              (v !== "Null" && !!v) ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        placeholder: "Message to request...",
                                      },
                                      model: {
                                        value: _vm.tplToWork.commentary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tplToWork,
                                            "commentary",
                                            $$v
                                          )
                                        },
                                        expression: "tplToWork.commentary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isChangeRequest ==
                        _vm.TYPE_CHANGE_METADA.PREVIEW_OWNER
                          ? _c(
                              VRow,
                              { attrs: { dense: "" } },
                              [
                                _c(VCol, { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "pb-2 font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.response_reason")
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  VCol,
                                  { staticClass: "col-md-12" },
                                  [
                                    _c(VTextarea, {
                                      attrs: {
                                        size: "sm",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        outlined: "",
                                        required: "",
                                        rules: [
                                          function (v) {
                                            return (
                                              (v !== "Null" && !!v) ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        placeholder: "...",
                                      },
                                      model: {
                                        value: _vm.tplToWork.response,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tplToWork,
                                            "response",
                                            $$v
                                          )
                                        },
                                        expression: "tplToWork.response",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12", lg: "12" } },
                              [
                                _c(
                                  "b-alert",
                                  {
                                    attrs: {
                                      show: _vm.dismissCountDown,
                                      dismissible: "",
                                      variant: "danger",
                                    },
                                    on: {
                                      dismissed: function ($event) {
                                        _vm.dismissCountDown = 0
                                      },
                                      "dismiss-count-down":
                                        _vm.countDownChanged,
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.dangerMessage)),
                                    ]),
                                    _c("b-progress", {
                                      attrs: {
                                        variant: "danger",
                                        max: _vm.dismissSecs,
                                        value: _vm.dismissCountDown,
                                        height: "4px",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }